<template>
    <section>
        <h3 class="text-uppercase mt-4">Subscription and billing</h3>
        <hr class="bar my-3" />
        <p>
            Your subscription is managed by
            <strong>{{ subscription.manager }} ({{ subscription.organization }})</strong>.
        </p>
    </section>
</template>

<script>
export default {
    name: "AccountManaged",
    props: ["subscription"],
};
</script>

<style scoped></style>
